import React, {useEffect, useState} from 'react'
import PageTitle from './include/PageTitle'
import Team from "./include/Team";
import {get_team_members} from "../Utils/Data";
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import {Helmet} from "react-helmet";

function About({title}) {
    const [team, setTeam] = useState([]);

    useEffect(() => {
        const fetchTeamMembers = async () => {
            const data = await get_team_members();
             if(data){
            setTeam(data);
            }
        };
        fetchTeamMembers();
    }, []);
    return (
        <><Helmet>
            <title>Zaala | About</title>
        </Helmet>
            <PageTitle title={title}/>

            <div className="xs-sidebar-group info-group info-sidebar">
                <div className="xs-overlay xs-bg-black"/>
                <div className="xs-sidebar-widget">
                    <div className="sidebar-widget-container">
                        <div className="widget-heading">
                            <a href="#" className="close-side-widget">
                                X
                            </a>
                        </div>
                        <div className="sidebar-textwidget">
                            <div className="sidebar-info-contents">
                                <div className="content-inner">
                                    <div className="logo">
                                        <a href="index.html">
                                            <img src="assets/img/resource/logo-1.png" alt=""/>
                                        </a>
                                    </div>
                                    <div className="content-box">
                                        <h4>About Us</h4>
                                        <div className="inner-text">
                                            <p>
                                                Contrary to popular belief, Lorem Ipsum is not simply random
                                                text. It has roots in a piece of classical Latin literature
                                                from 45 BC, making it over 2000 years old.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="form-inner">
                                        <h4>Get a free quote</h4>
                                        <form
                                            action="https://figtheme.com/html/techlab/index.html"
                                            method="post"
                                        >
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    placeholder="Name"
                                                    required=""
                                                />
                                            </div>
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    required=""
                                                />
                                            </div>
                                            <div className="form-group">
                  <textarea
                      name="message"
                      placeholder="Message..."
                      defaultValue={""}
                  />
                                            </div>
                                            <div className="form-group message-btn">
                                                <button
                                                    className="button-style-1"
                                                    type="submit"
                                                    data-loading-text="Please wait..."
                                                >
                                                    Submit Now
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="sidebar-contact-info">
                                        <h4>Contact Info</h4>
                                        <ul>
                                            <li>
                                                <span className="icon-pin"/> 88 broklyn street, New York
                                            </li>
                                            <li>
                                                <span className="icon-call"/>
                                                <a href="tel:123456789">+1 555-9990-153</a>
                                            </li>
                                            <li>
                                                <span className="fa fa-envelope"/>
                                                <a href="mailto:info@example.com">info@example.com</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="thm-social-link1">
                                        <ul className="social-box">
                                            <li className="facebook">
                                                <a href="#">
                                                    <i className="icon-facebook" aria-hidden="true"/>
                                                </a>
                                            </li>
                                            <li className="twitter">
                                                <a href="#">
                                                    <i className="icon-twitter" aria-hidden="true"/>
                                                </a>
                                            </li>
                                            <li className="linkedin">
                                                <a href="#">
                                                    <i className="icon-instagram" aria-hidden="true"/>
                                                </a>
                                            </li>
                                            <li className="gplus">
                                                <a href="#">
                                                    <i className="fab fa-pinterest" aria-hidden="true"/>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Team data={team}/>

            <div className="services-two mt-3">
                <div className="container">
                    <div className="section-title text-center tg-heading-subheading animation-style2">
                        <h5 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        u
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        w
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        r
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        k
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        f
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        o
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        w
                                    </div>
                                </div>
                            </div>
                        </h5>
                        <h2 className="tg-element-title" style={{perspective: 400}}>
                            <div
                                className="split-line"
                                style={{
                                    display: "block",
                                    textAlign: "center",
                                    position: "relative"
                                }}
                            >
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        E
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        l
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        v
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        a
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        g
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        B
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        u
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        s
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        w
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        h
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    {" "}
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        I
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        T
                                    </div>
                                </div>
                                {" "}
                                <div style={{position: "relative", display: "inline-block"}}>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        I
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        g
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        e
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        n
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        u
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        i
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        t
                                    </div>
                                    <div
                                        style={{
                                            position: "relative",
                                            display: "inline-block",
                                            transform: "translate(0px, 0px)",
                                            opacity: 1
                                        }}
                                    >
                                        y
                                    </div>
                                </div>
                            </div>
                        </h2>
                    </div>
                    <div className="row">
                        {/* Step 1: Understanding the Problem */}
                        <div className="col-xl-4 col-lg-4 text-center wow fadeInUp animated" data-wow-delay="0.1s">
                            <div className="services-two__single">
                                <div className="services-two__single-img">
                                    <div className="inner">
                                        <img src="assets/img/service/service-details-2.jpg"
                                             alt="Understanding the Problem"
                                             height="250px"
                                        />

                                    </div>
                                    <div className="icon-box">
                                        <span className="icon-question-mark"/>
                                    </div>
                                </div>
                                <div className="services-two__single-text">
                                    <h3>Understand & Analyze</h3>
                                    <p>Thoroughly analyze the problem to understand core requirements and objectives
                                        before moving forward.</p>
                                </div>
                            </div>
                        </div>

                        {/* Step 2: Brainstorm Solutions */}
                        <div className="col-xl-4 col-lg-4 text-center wow fadeInUp animated" data-wow-delay="0.3s">
                            <div className="services-two__single">
                                <div className="services-two__single-img">
                                    <div className="inner">
                                        <img height="250px"
                                             src="assets/img/service/service-details-1.jpg" alt="Brainstorm Solutions"/>
                                    </div>
                                    <div className="icon-box">
                                        <span className="icon-analycis"/>
                                    </div>
                                </div>
                                <div className="services-two__single-text">
                                    <h3>Ideation & Brainstorming</h3>
                                    <p>Generate ideas and explore potential solutions through brainstorming sessions and
                                        collaborative discussions.</p>
                                </div>
                            </div>
                        </div>

                        {/* Step 3: Planning */}
                        <div className="col-xl-4 col-lg-4 text-center wow fadeInUp animated" data-wow-delay="0.5s">
                            <div className="services-two__single">
                                <div className="services-two__single-img">
                                    <div className="inner">
                                        <img height="250px"
                                             src="assets/img/service/service-details-7.jpg" alt="Planning"/>
                                    </div>
                                    <div className="icon-box">
                                        <span className="icon-sparkle"/>
                                    </div>
                                </div>
                                <div className="services-two__single-text">
                                    <h3>Strategic Planning</h3>
                                    <p>Outline a clear and structured plan to execute the solution, ensuring all stages
                                        and resources are covered.</p>
                                </div>
                            </div>
                        </div>

                        {/* Step 4: Development */}
                        <div className="col-xl-4 col-lg-4 text-center wow fadeInUp animated" data-wow-delay="0.7s">
                            <div className="services-two__single">
                                <div className="services-two__single-img">
                                    <div className="inner">
                                        <img height="250px"
                                             src="assets/img/service/service-details-4.jpg" alt="Development"/>
                                    </div>
                                    <div className="icon-box">
                                        <span className="icon-checklist"/>
                                    </div>
                                </div>
                                <div className="services-two__single-text">
                                    <h3>Execution & Development</h3>
                                    <p>Bring the solution to life by building and refining it through a series of
                                        development stages and iterations.</p>
                                </div>
                            </div>
                        </div>

                        {/* Step 5: Testing */}
                        <div className="col-xl-4 col-lg-4 text-center wow fadeInUp animated" data-wow-delay="0.9s">
                            <div className="services-two__single">
                                <div className="services-two__single-img">
                                    <div className="inner">
                                        <img height="250px"
                                             src="assets/img/service/service-details-5.jpg" alt="Testing"/>
                                    </div>
                                    <div className="icon-box">
                                        <span className="icon-code-genius-hub"/>
                                    </div>
                                </div>
                                <div className="services-two__single-text">
                                    <h3>Testing & Validation</h3>
                                    <p>Conduct rigorous testing to ensure the solution meets all requirements and
                                        performs as expected.</p>
                                </div>
                            </div>
                        </div>

                        {/* Step 6: Deployment & Maintenance */}
                        <div className="col-xl-4 col-lg-4 text-center wow fadeInUp animated" data-wow-delay="1.1s">
                            <div className="services-two__single">
                                <div className="services-two__single-img">
                                    <div className="inner">
                                        <img height="250px"
                                             src="assets/img/service/service-details-6.jpg"
                                             alt="Deployment & Maintenance"/>
                                    </div>
                                    <div className="icon-box">
                                        <span className="icon-check"/>
                                    </div>
                                </div>
                                <div className="services-two__single-text">
                                    <h3>Deployment & Maintenance</h3>
                                    <p>Deploy the solution and provide ongoing maintenance and support to adapt to
                                        evolving needs.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <section className="about-two">
                <div className="container">
                    <div className="row">
                        {/* Start About Two Content*/}
                        <div className="col-xl-6">
                            <div className="about-two__content">
                                <div className="section-title tg-heading-subheading animation-style2">
                                    <h5 className="tg-element-title" style={{perspective: 400}}>
                                        <div
                                            className="split-line"
                                            style={{
                                                display: "block",
                                                textAlign: "start",
                                                position: "relative"
                                            }}
                                        >
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    A
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    b
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    o
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    u
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    t
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    U
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    s
                                                </div>
                                            </div>
                                        </div>
                                    </h5>
                                    <h2 className="tg-element-title" style={{perspective: 400}}>
                                        <div
                                            className="split-line"
                                            style={{
                                                display: "block",
                                                textAlign: "start",
                                                position: "relative"
                                            }}
                                        >
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    S
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    c
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    u
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    l
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    p
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    t
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    n
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    g
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    D
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    g
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    i
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    t
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    a
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    l
                                                </div>
                                            </div>
                                            {" "}
                                            <div style={{position: "relative", display: "inline-block"}}>
                                                {" "}
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    L
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    a
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    n
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    d
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    s
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    c
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    a
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    p
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    e
                                                </div>
                                                <div
                                                    style={{
                                                        position: "relative",
                                                        display: "inline-block",
                                                        transform: "translate(0px, 0px)",
                                                        opacity: 1
                                                    }}
                                                >
                                                    s
                                                </div>
                                            </div>
                                        </div>
                                    </h2>
                                </div>
                                <div className="text">
                                    <p>
                                        We are dedicated to delivering solutions that empower your business to thrive in
                                        a competitive market. Our team combines technical expertise with strategic
                                        insight to address your unique challenges and bring your vision to life. From
                                        project planning to full-scale execution, we work alongside you to ensure
                                        success at every stage.
                                    </p>
                                </div>
                                <div className="about-two__content-list-box">
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-6 col-md-6">
                                            <div className="about-two__content-list-box-single">
                                                <ul>
                                                    <li>
                                                        <div className="icon-box">
                                                            <span className="icon-checklist-2"/>
                                                        </div>
                                                        <p>Common Pitfalls to Avoid</p>
                                                    </li>
                                                    <li>
                                                        <div className="icon-box">
                                                            <span className="icon-checklist-2"/>
                                                        </div>
                                                        <p>Building a Resilient Startup</p>
                                                    </li>
                                                    <li>
                                                        <div className="icon-box">
                                                            <span className="icon-checklist-2"/>
                                                        </div>
                                                        <p>Understanding User Experience</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6">
                                            <div className="about-two__content-list-box-single">
                                                <ul>
                                                    <li>
                                                        <div className="icon-box">
                                                            <span className="icon-checklist-2"/>
                                                        </div>
                                                        <p>Effective Marketing Tactics</p>
                                                    </li>
                                                    <li>
                                                        <div className="icon-box">
                                                            <span className="icon-checklist-2"/>
                                                        </div>
                                                        <p>Strategies for Growth and Scaling</p>
                                                    </li>
                                                    <li>
                                                        <div className="icon-box">
                                                            <span className="icon-checklist-2"/>
                                                        </div>
                                                        <p>Choosing the Right Tools & Tech</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* End About Two Content*/}
                        {/* Start About Two Img*/}
                        <div
                            className="col-xl-6 wow fadeInRight"
                            data-wow-delay=".3s"
                            style={{
                                visibility: "visible",
                                animationDelay: "0.3s",
                                animationName: "fadeInRight"
                            }}
                        >
                            <div className="about-two__img">
                                <div className="inner">
                                    <img src="assets/img/about/about-two__img1.jpg" alt=""/>
                                    <div className="about-two__video">
                                        <a
                                            href="https://www.youtube.com/watch?v=6mkoGSqTqFI"
                                            className="about-two__video-btn popup-video"
                                        >
                                            <span className="icon-play-button-arrowhead"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End About Two Img*/}
                    </div>
                </div>
            </section>


        </>
    )
}

export default About
